<template>
  <GeneralAdviceVue/>
</template>

<script>
import GeneralAdviceVue from '../../../components/academic/GeneralAdvice.vue'

export default {
components:{
    GeneralAdviceVue
}
}
</script>

<style>

</style>